/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {

    export function meevoAutoCapitalizationSearchNameFilter(): angular.IFilterService {
        const filter = (input: any) => {

            if (!input) {
                return "";
            }

            //      var name = input.toString().replace(/[^A-Z\s\-.'.,..]/gi, "");
            //remove non-alpha characters
            var name = input.toString().replace(/^\s+/g, '');
            //var name = input.toString().replace(/^\s+|([\^!\$%&\(\)\*\./:;\?@\[\\\]_\{\|\}¨ˇ“”€\+<>§°¤®™©])/g, '');///^\s+|([\^\-!#\$%&\(\)\*\./:;\?@\[\\\]_\{\|\}¨ˇ“”€\+<=>§°\d¤®™©])/g
            //      return input.toString().replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
            return name.charAt(0).toUpperCase() + name.substr(1);
        };
        return filter;
    }


    angular.module("meevo.components.filters")
        .filter("meevoAutoCapitalizationSearchName", meevoAutoCapitalizationSearchNameFilter);
}
